import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectHeaderState, selectIsBackUpNav } from '../../store/slice';
import { RootState } from 'src/app/store';
import { CustomPopper } from '../CustomPopper/CustomPopper';
import { IA2AccountDropdown } from './IA2AccountDropdown';
import { AccountInfo } from './AjaxFetchAccountInfo';

import { AccountDropdownWrapper } from './styles';
import { AccountSwitcherPublisher } from 'src/commons/utils/metrics';
import { IA2AccountDropdownTrigger } from './IA2AccountDropdownTrigger';

interface AccountDropdownProps {
  /*
   * When adding hasConsoleBanner (https://sim.amazon.com/issues/CCX-15314)
   * adjust max height of AccountDropdownWrapper
   */
  currentAccountInfo: AccountInfo;
  isBackUpNav: boolean;
}

export const AccountDropdown: React.VFC<AccountDropdownProps> = ({
  currentAccountInfo,
  isBackUpNav,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentMarketplaceId = currentAccountInfo.currentMarketplaceId;
  const advertisingAccountsDataTaktId =
    currentMarketplaceId === currentAccountInfo?.currentMarketplaceId
      ? 'aac-account-links-same-mp'
      : `aac-account-links-different-mp-${currentMarketplaceId}`;

  const handleToggle = () => {
    if (isOpen) {
      AccountSwitcherPublisher.publishCounterMonitor('Close', 1);
    } else {
      AccountSwitcherPublisher.publishCounterMonitor('Open', 1);
    }
    setIsOpen(!isOpen);
  };

  const handleClose = () => setIsOpen(false);

  return (
    <CustomPopper
      isOpen={isOpen}
      autoFocus={true}
      trigger={
        <IA2AccountDropdownTrigger
          isOpen={isOpen}
          handleToggle={handleToggle}
        />
      }
      position="bottom"
      align="start"
      strategy="fixed"
      onCloseButtonClick={handleClose}
      spacing={0}
      padding="none"
      zIndex={500}
      data-ccx-e2e-id="aac-account-dropdown-wrapper"
    >
      {!isBackUpNav && (
        <AccountDropdownWrapper>
          <IA2AccountDropdown
            advertisingAccountsDataTaktId={advertisingAccountsDataTaktId}
          />
        </AccountDropdownWrapper>
      )}
    </CustomPopper>
  );
};

const mapStateToProps = (state: RootState) => {
  const headerState = selectHeaderState(state);
  const isBackUpNav = selectIsBackUpNav(state);
  return {
    currentAccountInfo: headerState.currentAccountInfo as AccountInfo,
    isBackUpNav: isBackUpNav,
  };
};

export default connect(mapStateToProps)(AccountDropdown);
